// @ts-strict-ignore
import {Injectable, Injector, Optional} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {SimPromiseDelayService} from "./sim-promise-delay.service";
import {SimRecorderService} from "../../../api/generated/service";
import {EventEmitterService} from "@event-emitter";

@Injectable({
	providedIn: "root",
})
export class SimActiveRecordingsService {
	private readonly activeTrainingSessionSubject: BehaviorSubject<{
		trainingSessionId: string;
	}> = new BehaviorSubject({trainingSessionId: null});
	public readonly activeTrainingSession = this.activeTrainingSessionSubject.asObservable();

	constructor(
		injector: Injector,
		@Optional() private readonly _emitterService: EventEmitterService,
		private _simPromiseDelayService: SimPromiseDelayService,
		private _simRecordingService: SimRecorderService,
	) {
		if (!this._emitterService) {
			this._emitterService = new EventEmitterService(injector);
		}

		this._emitterService.onRecordingStarted.subscribe(() => this.loadRunningTrainingSessions());
		this._emitterService.onRecordingStopped.subscribe(() => this.loadRunningTrainingSessions());
		this._emitterService.onTrainingSessionUpdated.subscribe(() => this.loadRunningTrainingSessions());
		this._emitterService.onScenarioRecordingChanged.subscribe(() => this.loadRunningTrainingSessions());

		this.loadRunningTrainingSessions();
	}

	public refresh() {
		this.loadRunningTrainingSessions();
	}

	private loadRunningTrainingSessions() {
		this._simPromiseDelayService.callWithMinimunDelay(
			"loadRunningTrainingSessions",
			() =>
				this._simRecordingService
					.getActiveTrainingSessionsForRecorder()
					.then((data) => {
						this.activeTrainingSessionSubject.next(data);
					})
					.catch((err) => {
						console.debug(err);
					}),
			2000,
		);
	}
}
